import React from 'react';
import { Route } from 'react-router-dom';
import { TemplatesPage } from './Routes';

export const routes = [<Route key={0} path="/project-templates" component={TemplatesPage} />];

export const navigation = [
    { name: 'project_templates', link: '/project-templates', match: '/project-templates', icon: 'Template' },
];
